/*
 * @创建文件时间: 2019-11-16 18:40:17
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-19 13:52:25
 * @联系Qq:1360484677
 * @文件介绍: 
 */
export default [{
    path: 'bridgeTable',
    name: 'bridgeTable',
    meta: {
        title: '桥梁',
        auth: true
    },
    component: () =>
        import ('@/views/basic/structure/bridgeTable')
}, {
    path: 'tunnelTable',
    name: 'tunnelTable',
    meta: {
        title: '隧道',
        auth: true
    },
    component: () =>
        import ('@/views/basic/structure/tunnelTable')
}, {
    path: 'bridgeCard',
    name: 'bridgeCard',
    meta: {
        title: '桥梁卡片',
        auth: true
    },
    component: () =>
        import ('@/views/basic/structure/bridgeCard')
}, {
    path: 'culvertTable',
    name: 'culvertTable',
    meta: {
        title: '涵洞',
        auth: true
    },
    component: () =>
        import ('@/views/basic/structure/culvertTable')
}]